<div class="mt-4 flex items-center justify-between gap-4">
  <h2 class="text-sm font-semibold uppercase tracking-wide text-dusk">Your picks</h2>
  <a
    [routerLink]="['/competitions', competitionId(), 'leaderboard']"
    class="text-xs text-dusk hover:text-parchment hover:underline"
    >Leaderboard &rarr;</a
  >
</div>

@if (buttonLabel(); as label) {
  <a
    [routerLink]="['/competitions', competitionId(), 'picks']"
    class="mt-3 inline-flex items-center justify-center rounded-[3px] bg-gradient-to-b from-gold to-gold-dim px-5 py-2.5 text-sm font-bold text-ink transition hover:-translate-y-px"
    >{{ label }}</a
  >
}

<div class="mt-3 overflow-x-auto rounded-md border border-hairline bg-panel">
  @if (rows().length === 0) {
    <p class="p-6 text-sm text-dusk">
      {{ pastCutoff() ? "You didn't submit any picks before the cutoff." : 'No picks yet.' }}
    </p>
  } @else {
    <!-- Phones get one stacked card per pick; the table needs room for its six columns. -->
    <ul class="divide-y divide-hairline lg:hidden">
      @for (row of rows(); track row.pick.id) {
        <li class="px-4 py-3 text-sm">
          <div class="flex items-start justify-between gap-3">
            <span class="text-parchment">
              {{ row.pick.person.name }}
              @if (row.age !== null) {
                ({{ row.age }})
              }
              @if (row.pick.isAlternate) {
                <span class="ml-1 text-xs text-dusk">(alt)</span>
              }
            </span>
            @if (row.points) {
              <span class="shrink-0 font-semibold text-gold">{{ row.points }} pts</span>
            }
          </div>
          @if (row.pick.person.dateOfDeath) {
            <p class="mt-1 text-xs text-dusk">
              Died {{ dateOnly(row.pick.person.dateOfDeath) }}
              @if (row.pick.person.causeOfDeath) {
                · {{ row.pick.person.causeOfDeath }}
              }
            </p>
          }
          @if (row.prizeDescriptions.length > 0) {
            <p class="mt-1 text-xs text-parchment">Bonus: {{ row.prizeDescriptions.join(', ') }}</p>
          }
          @for (award of row.awards; track award.awardId) {
            <p class="mt-1 text-xs text-dusk">{{ award.name }} ({{ awardValue(award) }})</p>
          }
        </li>
      }
    </ul>

    <table class="hidden w-full text-left text-sm lg:table">
      <thead>
        <tr class="border-b border-hairline text-xs uppercase tracking-wide text-dusk">
          <th class="px-4 py-3 font-semibold">Name (Age)</th>
          <th class="px-4 py-3 font-semibold">Date of death</th>
          <th class="px-4 py-3 font-semibold">Cause</th>
          <th class="px-4 py-3 font-semibold">Points</th>
          <th class="px-4 py-3 font-semibold">Bonus</th>
          <th class="px-4 py-3 font-semibold">Notes</th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows(); track row.pick.id) {
          <tr class="border-b border-hairline last:border-0">
            <td class="px-4 py-3 text-parchment">
              {{ row.pick.person.name }}
              @if (row.age !== null) {
                ({{ row.age }})
              }
              @if (row.pick.isAlternate) {
                <span class="ml-1 text-xs text-dusk">(alt)</span>
              }
            </td>
            <td class="px-4 py-3 text-dusk">
              {{ row.pick.person.dateOfDeath ? dateOnly(row.pick.person.dateOfDeath) : '—' }}
            </td>
            <td class="px-4 py-3 text-dusk">{{ row.pick.person.causeOfDeath ?? '—' }}</td>
            <td class="px-4 py-3 text-parchment">{{ row.points || '—' }}</td>
            <td class="px-4 py-3 text-parchment">
              {{ row.prizeDescriptions.length > 0 ? row.prizeDescriptions.join(', ') : '—' }}
            </td>
            <td class="px-4 py-3 text-dusk">
              @if (row.awards.length === 0) {
                —
              } @else {
                @for (award of row.awards; track award.awardId) {
                  <div>
                    {{ award.name }}
                    ({{ awardValue(award) }})
                  </div>
                }
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>

@if (otherAwards().length > 0) {
  <p class="mt-3 text-xs text-dusk">
    Other awards:
    @for (award of otherAwards(); track award.awardId) {
      <span class="mr-3 text-parchment">{{ award.name }} ({{ awardValue(award) }})</span>
    }
  </p>
}
